import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftReportProgress,
  CftActionsButtons,
  CftExportReport,
  CftTank,
} from "../../components";
import routes from "../../utils/cftRoutes";
import { useCft } from "../../utils/CftProvider";
import CarbonChangesForm, {
  CarbonChangesFormContext,
} from "../../forms/farmlands/CarbonChangesForm/CarbonChanges.form";

function CarbonChangesPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { submitForm, values, isSubmitting } = useFormikContext();
  const { saveFarmlands, meta } = useCft();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={70}
          cropName={meta.title.farmlands}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportReport type="farmlands" />

              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveFarmlands({
                    carbonChanges: values,
                  });
                  history.push(routes.FARMLANDS.MAIN);
                }}
              />
            </CftTank>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:carbonChanges.title", "Zmiany węglowe")}
          onBack={() => history.push(routes.FARMLANDS.IRRIGATION)}
          onNext={submitForm}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:carbonChanges.title", "Zmiany węglowe")}</h3>
            <p>
              {t(
                "cft:carbonChanges.subtitle",
                "Zaznacz odpowiednie pola poniżej, jeśli w ciągu ostatnich 20 lat dokonałeś zmian w użytkowaniu gruntów, uprawie lub uprawie okrywowej / międzyplonowej na obszarze oceny."
              )}
            </p>
          </>
        }
      >
        <CarbonChangesForm />
        <CftReportProgress type="farmlands" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <CarbonChangesFormContext>
      <CarbonChangesPage />
    </CarbonChangesFormContext>
  );
};
